module.exports = __webpack_public_path__ + "static/img/four.81ad271.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/strawberryImg/four.png
// module id = zDgv
// module chunks = 1